import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { isUndefinedOrEmpty } from '@/helpers/helpers';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: {
            title: 'Progressive Homeowners Insurance & Property Insurance | Progressive'
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/utility/NotFound.vue'),
        meta: {
            title: '404 Not Found | Progressive'
        }
    },
    {
        path: '/claims/claims-center',
        name: 'claimscenter_old',
        component: () => import('@/views/claims/ClaimsCenterView.vue'),
        meta: {
            title: 'Claims Center | Progressive'
        }
    },
    {
        path: '/claims-center',
        name: 'claimscenter',
        component: () => import('@/views/claims/ClaimsCenterView.vue'),
        meta: {
            title: 'Claims Center | Progressive'
        }
    },
    {
        path: '/claims/about-the-claims-process',
        name: 'aboutclaimsprocess_old',
        component: () => import('@/views/claims/AboutClaimsProcessView.vue'),
        meta: {
            title: 'About the Claims Process | Progressive'
        }
    },
    {
        path: '/claims-center/about-the-claims-process',
        name: 'aboutclaimsprocess',
        component: () => import('@/views/claims/AboutClaimsProcessView.vue'),
        meta: {
            title: 'About the Claims Process | Progressive'
        }
    },
    {
        path: '/claims/claims-faqs',
        name: 'claimsfaq_old',
        component: () => import('@/views/claims/ClaimsFaqsView.vue'),
        meta: {
            title: 'Claims FAQs | Progressive'
        }
    },
    {
        path: '/claims-center/claims-faq',
        name: 'claimsfaq',
        component: () => import('@/views/claims/ClaimsFaqsView.vue'),
        meta: {
            title: 'Claims FAQs | Progressive'
        }
    },
    {
        path: '/claims/report-fraud',
        name: 'reportfraud_old',
        component: () => import('@/views/claims/ReportFraudView.vue'),
        meta: {
            title: 'Report Fraud | Progressive'
        }
    },
    {
        path: '/claims-center/report-fraud',
        name: 'reportfraud',
        component: () => import('@/views/claims/ReportFraudView.vue'),
        meta: {
            title: 'Report Fraud | Progressive'
        }
    },
    {
        path: '/legal',
        name: 'legal',
        component: () => import('@/views/legal/TermsOfUseView.vue'),
        meta: {
            title: 'Legal Statement | Progressive'
        }
    },
    {
        path: '/claims-center/report-a-claim',
        name: 'reportaclaim',
        component: () => import('@/views/claims/ReportAClaim.vue'),
        meta: {
            title: 'Report a Claim | Progressive'
        }
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('@/views/utility/GlobalErrorView.vue'),
        meta: {
            title: 'Error | Progressive'
        }
    },
    {
        path: '/404',
        name: 'notfound',
        component: () => import('@/views/utility/NotFound.vue'),
        meta: {
            title: '404 Not Found | Progressive'
        }
    },
    {
        path: '/timeout',
        name: 'timeout',
        component: () => import('@/views/utility/Timeout.vue'),
        meta: {
            title: 'Timeout | Progressive'
        }
    },
    {
        path: '/insurance/flood-insurance',
        name: 'floodinsurance',
        component: () => import('@/views/insurance/FloodInsuranceView.vue'),
        meta: {
            title: 'Flood Insurance | Progressive'
        }
    },
    {
        path: '/support',
        name: 'support',
        redirect: '',
        beforeEnter() {
            window.location.href = "https://www.progressive.com/contact-us/";
        }
    },
    {
        path: '/agent-privacy',
        name: 'agentprivacy',
        component: () => import('@/views/standalone/AgentPrivacy.vue'),
        meta: {
            title: 'Agent Privacy | Progressive'
        }
    },
    {
        path: '/insurance',
        name: 'insurance',
        redirect: '',
        beforeEnter() {
            window.location.href = "https://www.progressive.com/insurance/";
        }
    },
    {
        path: '/insurance/homeowners-insurance',
        name: 'homeowners-insurance',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressive.com/homeowners/";
        }
    },
    {
        path: '/insurance/condo-insurance',
        name: 'condo',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressive.com/condo/";
        }
    },
    {
        path: '/insurance/renters-insurance',
        name: 'renters',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressive.com/renters/";
        }
    },
    {
        path: '/insurance/seasonal-insurance',
        name: 'seasonal',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressive.com/answers/second-home-insurance/";
        }
    },
    {
        path: '/insurance/umbrella-insurance',
        name: 'umbrella-insurance',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressive.com/insurance/umbrella/";
        }
    },
    {
        path: '/policyholders/',
        name: 'policyholdersRedirect',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressive.com/homeowners/";
        }
    },
    {
        path: '/policyholders/understanding-my-policy',
        name: 'understandingmypolicy',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressive.com/answers/how-to-read-an-insurance-policy/";
        }
    },
    {
        path: '/policyholders/insurance-terms/',
        name: 'insuranceterms',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressive.com/answers/property-insurance-glossary/";
        }
    },
    {
        path: '/policyholders/loss-prevention/',
        name: 'lossprevention',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressive.com/answers/home-insurance/";
        }
    },
    {
        path: '/policyholders/faq/',
        name: 'faq',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressive.com/homeowners/faq/";
        }
    },
    {
        path: '/asi-and-progressive-insurance',
        name: 'asiandProgressiveInsurance',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://progressive.mediaroom.com/news-releases/?item=122454";
        }
    },
    {
        path: '/insurance/find-an-agent',
        name: 'findanAgent',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressiveagent.com/find-an-agent/";
        }
    },
    {
        path: '/asi-and-progressive-insurance',
        name: 'insuranceASI',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://progressive.mediaroom.com/news-releases/?item=122454";
        }
    },
    {
        path: '/insurance/find-an-agent',
        name: 'whereAgentHaveYouSeenHim',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressiveagent.com/find-an-agent/";
        }
    },
    {
        path: '/media-contacts/',
        name: 'redirectMediaContacts',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://progressive.mediaroom.com/";
        }
    },
    {
        path: '/offers/',
        name: 'redirectoffers',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressive.com/perkshare/";
        }
    },
    {
        path: '/confirmation/',
        name: 'optoutconfirmation',
        component: () => import('@/views/utility/OptOutConfirmationView.vue')
    },
    {
        path: '/news-archives/',
        name: 'redirectNewsArchives',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://progressive.mediaroom.com/";
        }
    },
    {
        path: '/Downloads/Documents/content-inventory-list.doc',
        name: 'redirectContentInventoryList',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = "https://www.progressive.com/answers/how-to-create-a-home-inventory/";
        }
    },
    {
        path: '/site-map/',
        name: 'redirectSiteMap',
        redirect: '',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        beforeEnter(to, from, next) {
            window.location.href = " https://www.progressive.com/sitemap/";
        }
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth'
            }
        } else if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    }
});

router.beforeEach((to, from, next) => {
    // Set page title from route meta
    if (to.meta !== undefined && !isUndefinedOrEmpty(to.meta.title)) {
        document.title = to.meta.title as string;
    } else {
        document.title = 'Corporate Portal | Progressive';
    }
    next();
});

export default router
